import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  mockCycleBuckets,
  mockOrdersStatus,
  mockPickingStats,
  mockProcessMetrics,
  mockProcessShare,
  mockSkuSnapshot,
  mockTaskSummary,
} from '../mock/dashboardData';
import FulfillmentCycleChart from './charts/FulfillmentCycleChart';
import OrdersStatusChart from './charts/OrdersStatusChart';
import PickingStatsCard from './charts/PickingStatsCard';
import ProcessShareChart from './charts/ProcessShareChart';
import SkuLevelSummary from './charts/SkuLevelSummary';
import TaskThroughputChart from './charts/TaskThroughputChart';

export const WarehouseDashboardInsights: React.FC = () => {
  const { t } = useTranslation('app');

  return (
    <div className="w-full flex-1">
      <h2 className="mb-6 text-2xl font-bold">{t('Warehouse Insights')}</h2>
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
        {/* Left Column - Picking Stats */}
        <div className="space-y-4">
          <PickingStatsCard data={mockPickingStats} />
          <ProcessShareChart
            shareData={mockProcessShare}
            metrics={mockProcessMetrics}
          />
        </div>

        {/* Middle and Right Columns - Charts */}
        <div className="space-y-4 lg:col-span-2">
          <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
            <OrdersStatusChart data={mockOrdersStatus} />
            <TaskThroughputChart data={mockTaskSummary} />
          </div>
          <SkuLevelSummary data={mockSkuSnapshot} />
          <FulfillmentCycleChart data={mockCycleBuckets} />
        </div>
      </div>
    </div>
  );
};

export default WarehouseDashboardInsights;
